import {
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";

const HeadingValue = {
  fontSize: "18px",
  fontWeight: "800",
};
interface Props {
  data: any;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

interface Skill {
  keywords: string[];
  level: string;
  requirement: string;
  skill: string;
}

const GeneratedJdResponse: React.FC<Props> = ({ data }) => {
  let functionalSkill = data?.functionalSkills?.map(
    (item: any) => item?.skill?.name
  );
  let technicalSkills = data?.technicalSkills?.map(
    (item: any) => item?.skill?.name
  );
  return (
    <CardContent
      sx={{
        maxHeight: "400px",
        overflowY: "auto",
        width: "100%",
        fontFamily: "Lato !important",
        "&::-webkit-scrollbar": {
          width: "4px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1",
        },
      }}
    >
      <Grid container>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography
              style={{
                fontSize: "24px",
                fontWeight: "800",
              }}
            >
              Title:
            </Typography>
            <Typography>{data?.jobTitle}</Typography>
          </Box>
        </Grid>

        <Grid item xs={12}></Grid>
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: "24px", fontWeight: "800", marginTop: "2px" }}
          >
            Description:
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>{data?.description}</Typography>
        </Grid>
        {data?.rolesAndResponsibilities &&
          data?.rolesAndResponsibilities.length > 0 && (
            <Grid item xs={12} pt={3}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography
                    style={{
                      fontSize: "24px",
                      fontWeight: "800",
                      marginTop: "2px",
                    }}
                  >
                    Roles & Responsibilities:
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography>
                    {data?.rolesAndResponsibilities?.map((n: any) => (
                      <>
                        - {n}
                        <br />
                      </>
                    ))}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          )}

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                style={{
                  fontSize: "24px",
                  fontWeight: "800",
                  marginTop: "2px",
                }}
              >
                Client:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>{data?.aboutClient}</Typography>
            </Grid>
          </Grid>
        </Grid>
        {data?.education && data?.education.length > 0 && (
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginTop: "2px",
                  }}
                >
                  Education:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  {data?.education?.map((n: any) => (
                    <>
                      - {n?.degree}{" "}
                      {n?.major && n?.major !== "" && "- Major: " + n?.major}
                      <br />
                    </>
                  ))}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
        {functionalSkill && functionalSkill.length > 0 && (
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginTop: "2px",
                  }}
                >
                  Functional skills:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ul style={{ marginTop: 0, marginBottom: 0 }}>
                  {renderSkillsByRequirement(data?.functionalSkills)}
                </ul>
              </Grid>
            </Grid>
          </Grid>
        )}
        {technicalSkills && technicalSkills.length > 0 && (
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginTop: "2px",
                  }}
                >
                  Technical skills:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ul style={{ marginTop: 0, marginBottom: 0 }}>
                  {renderSkillsByRequirement(data?.technicalSkills)}
                </ul>
              </Grid>
            </Grid>
          </Grid>
        )}
        {data?.certifications && data?.certifications.length > 0 && (
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontSize: "24px",
                    fontWeight: "800",
                    marginTop: "2px",
                  }}
                >
                  Certifications:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ul style={{ marginTop: 0, marginBottom: 0 }}>
                  {renderCertificateByRequirement(data?.certifications)}
                </ul>
              </Grid>
            </Grid>
          </Grid>
        )}

        {data?.licenses && data?.licenses.length > 0 && (
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Typography style={{ fontSize: "24px", fontWeight: "800" }}>
                  Licenses:
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>
                  {data.licenses?.map((n: any) => (
                    <Chip
                      key={n?.name}
                      color="primary"
                      label={n?.name}
                      style={{
                        marginTop: "10px",
                        marginLeft: "16px",
                      }}
                    />
                  ))}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </CardContent>
  );
};

export default GeneratedJdResponse;

const renderSkillsByRequirement = (skillData: any) => {
  const groupedSkills: { [key: string]: Skill[] } = {};

  // Group skills by requirement
  skillData.forEach((skill: Skill) => {
    if (!groupedSkills[skill.requirement]) {
      groupedSkills[skill.requirement] = [];
    }
    groupedSkills[skill.requirement].push(skill);
  });

  // Render skills for each requirement
  return Object.entries(groupedSkills).map(([requirement, skills]) => (
    <>
      <li>
        <div key={requirement}>
          <strong>{requirement}:</strong>
          <List style={{ paddingTop: 0, paddingBottom: 0 }}>
            {skills.map((skill) => (
              <ListItem
                key={skill.skill}
                style={{ paddingTop: 0, paddingBottom: 0 }}
              >
                <ListItemText
                  primary={
                    <React.Fragment>
                      <strong>{skill?.skill}</strong>:{" "}
                      {skill?.keywords?.join(", ")}
                    </React.Fragment>
                  }
                  secondary={skill.level ? `Level: ${skill.level}` : null}
                />
              </ListItem>
            ))}
          </List>
        </div>
      </li>
    </>
  ));
};

const renderCertificateByRequirement = (sertificateData: any) => {
  const groupedSkills: { [key: string]: any[] } = {};

  // Group skills by requirement
  sertificateData.forEach((skill: any) => {
    if (!groupedSkills[skill.requirement]) {
      groupedSkills[skill.requirement] = [];
    }
    groupedSkills[skill.requirement].push(skill);
  });

  // Render skills for each requirement
  return Object.entries(groupedSkills).map(([requirement, certificates]) => (
    <>
      <li>
        <div key={requirement}>
          <strong>{requirement}:</strong>
          <List style={{ paddingTop: 0, paddingBottom: 0 }}>
            {certificates.map((certificate) => (
              <ListItem
                key={certificate.name}
                style={{ paddingTop: 0, paddingBottom: 0 }}
              >
                <ListItemText
                  primary={
                    <React.Fragment>- {certificate?.name}</React.Fragment>
                  }
                />
              </ListItem>
            ))}
          </List>
        </div>
      </li>
    </>
  ));
};
